//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DocumentsPreviewerLoader from "./documents-previewer-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentPreviewer",
  components: {
    DocumentsPreviewerLoader
  },
  props: {
    url: {
      type: String,
      required: true
    },
    documentType: {
      type: [String, Boolean],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingIFrame: true,
      intervalId: null,
      forceReload: false
    };
  },
  computed: {
    encodedURL() {
      return encodeURIComponent(this.url);
    },
    docPreviewURL() {
      return `https://docs.google.com/gview?embedded=true&url=${this.encodedURL}`;
    }
  },
  watch: {
    url() {
      this.clearCurrentInterval();
      this.updateLoading(true);
      this.forceReload = true;
      this.checkIFrame();
    }
  },
  destroyed() {
    this.clearCurrentInterval();
  },
  mounted() {
    this.checkIFrame();
  },
  methods: {
    clearCurrentInterval() {
      if (!this.intervalId) return;
      clearInterval(this.intervalId);
    },
    checkIFrame() {
      this.intervalId = setInterval(async () => {
        const reloadIFrame = await this.hasIFrameLoadFail();
        if (reloadIFrame || this.forceReload) {
          this.forceReload = false;
          this.updateLoading(true);
          await this.$nextTick();
          if (this.$refs.docIFrame) this.$refs.docIFrame.src = this.docPreviewURL;
          return;
        }
        this.clearCurrentInterval();
        this.updateLoading(false);
      }, 2000);
    },
    async hasIFrameLoadFail() {
      var _this$$refs$docIFrame, _this$$refs$docIFrame2, _this$$refs$docIFrame3;
      await this.$nextTick();
      await this.$nextTick();
      return ((_this$$refs$docIFrame = this.$refs.docIFrame) == null ? void 0 : (_this$$refs$docIFrame2 = _this$$refs$docIFrame.contentDocument) == null ? void 0 : (_this$$refs$docIFrame3 = _this$$refs$docIFrame2.body) == null ? void 0 : _this$$refs$docIFrame3.innerHTML) === "";
    },
    updateLoading(loadingIFrame) {
      this.loadingIFrame = loadingIFrame;
      this.$emit("update:loadingIFrame", loadingIFrame);
    }
  }
});